import React, { useState } from 'react';
import Layout from './components/layout';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import './App.css';
import Tables from './components/tables';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
	descriptionStyle: {
		display: 'none',
	},

	listStyle: {
		// margin: '0 auto',
		// padding: '15px',
		// maxWidth: '750px',
	},

	btnWrapper: {
		margin: '20px',
		// padding: '15px',
		// maxWidth: '680px',
		// backgroundColor: 'blue',
	},

	btnStyle: {
		background: 'deepskyblue',
		letterSpacing: '1.3px',
		color: 'white',
	},

	btnReset: {
		marginTop: '20px',
		letterSpacing: '1.3px',
	},

	textFieldStyle: {
		background: 'white',

		color: 'white',
		'& label.Mui-focused': {
			color: '#999',
		},
		'& .MuiOutlinedInput-input': {
			color: '#999',
		},
		'&::placeholder': {
			color: 'white !important',
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: 'whitesmoke',
		},
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: 'whitesmoke',
			},
			'&:hover fieldset': {
				borderColor: 'white',
			},
			'&.Mui-focused fieldset': {
				borderColor: 'white',
			},
		},
	},
}));

function App() {
	const classes = useStyles();
	const [highPirce, setHighPirce] = useState('');
	const [lowPrice, setLowPrice] = useState('');
	const [closePrice, setClosePrice] = useState('');
	const [piviotPoint, setPiviotPoint] = useState(null);
	const [r1, setR1] = useState(null);
	const [r2, setR2] = useState(null);
	const [r3, setR3] = useState(null);

	const [s1, setS1] = useState(null);
	const [s2, setS2] = useState(null);
	const [s3, setS3] = useState(null);

	const saveLink = () => {
		const high = parseFloat(highPirce);
		const low = parseFloat(lowPrice);
		const close = parseFloat(closePrice);
		const test = high + low + close;
		const piviot = test / 3;
		setPiviotPoint(piviot.toFixed(4));

		const r1Resistance = piviot + (high - low) * 0.382;
		setR1(r1Resistance.toFixed(4));

		const r2Resistance = piviot + (high - low) * 0.618;
		setR2(r2Resistance.toFixed(4));

		const r3Resistance = piviot + (high - low) * 1;
		setR3(r3Resistance.toFixed(4));

		const s1Support = piviot - (high - low) * 0.382;
		setS1(s1Support.toFixed(4));

		const s2Support = piviot - (high - low) * 0.618;
		setS2(s2Support.toFixed(4));

		const s3Support = piviot - (high - low) * 1;
		setS3(s3Support.toFixed(4));
		// console.log(piviot);
	};

	const onReset = () => {
		setHighPirce('');
		setLowPrice('');
		setClosePrice('');
		setPiviotPoint(null);
		setR1(null);
		setR2(null);
		setR3(null);
		setS1(null);
		setS2(null);
		setS3(null);
	};

	return (
		<div className='App'>
			<Layout>
				{/* <h1>High {typeof parseFloat(highPirce)}</h1>
				<h1>PP {piviotPoint}</h1>
				<h1>Resistance 1 - low {r1}</h1>
				<h1>Resistance 2 - low {r2}</h1>
				<h1>Resistance 3 - low {r3}</h1>
				<h1>Support 1 - low {s1}</h1>
				<h1>Support 2 - low {s2}</h1>
				<h1>Support 3 - low {s3}</h1>
				piviotPoint
				<h1>Low {lowPrice}</h1>
				<h1>Close {closePrice}</h1> */}
				<div>
					<List className={classes.listStyle}>
						<ListItem>
							<TextField
								// label='High'
								placeholder='High'
								type='number'
								name='highPirce'
								onChange={(e) => setHighPirce(e.target.value)}
								variant='outlined'
								value={highPirce}
								fullWidth={true}
								inputProps={{ maxLength: 10 }}
								className={classes.textFieldStyle}
							/>
						</ListItem>
						<ListItem>
							<TextField
								// label='low'
								placeholder='Low'
								name='lowPrice'
								type='number'
								onChange={(e) => setLowPrice(e.target.value)}
								variant='outlined'
								value={lowPrice}
								fullWidth={true}
								inputProps={{ maxLength: 10 }}
								className={classes.textFieldStyle}
							/>
						</ListItem>
						<ListItem>
							<TextField
								// label='Close'
								placeholder='Close'
								name='closePrice'
								type='number'
								onChange={(e) => setClosePrice(e.target.value)}
								variant='outlined'
								value={closePrice}
								fullWidth={true}
								inputProps={{ maxLength: 10 }}
								className={classes.textFieldStyle}
							/>
						</ListItem>
					</List>
				</div>
				<div className={classes.btnWrapper}>
					<Button
						// color='primary'
						variant='contained'
						onClick={() => saveLink()}
						disabled={
							highPirce !== '' && lowPrice !== '' && closePrice !== ''
								? false
								: true
						}
						fullWidth={true}
						className={classes.btnStyle}
					>
						Calculate
					</Button>

					{highPirce !== '' || lowPrice !== '' || closePrice !== '' ? (
						<Button
							className={classes.btnReset}
							onClick={() => onReset()}
							fullWidth={true}
							variant='contained'
							color='secondary'
						>
							Reset
						</Button>
					) : (
						''
					)}
				</div>
				<Tables
					piviotPoint={piviotPoint}
					r1={r1}
					r2={r2}
					r3={r3}
					s1={s1}
					s2={s2}
					s3={s3}
				/>
			</Layout>
		</div>
	);
}

export default App;
